import { Box, Text } from '@factorialco/deprecated-design-system'

import DayPicker from 'modules/core/components/DayPicker'
import FormRow from 'modules/core/components/FormRow'
import i18n from 'modules/core/lib/i18n'

import ContractTooltip from 'modules/contracts/components/ContractDetails/ContractTooltip'

interface Props {
  value: string
  onChange: (value: string) => void
  minDate?: Date
  maxDate?: Date
  readonly?: boolean
}

function EmployeeTerminationDatePicker({ value, onChange, minDate, maxDate, readonly }: Props) {
  return (
    <FormRow>
      <Box gap="s8">
        <Box flexDirection="row" alignItems="center" gap="s4" height="s24">
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('contract_versions.header.pause_resume.pause_modal.end_access_to_factorial')}
          </Text>
          <ContractTooltip
            information={i18n.t(
              'contract_versions.header.pause_resume.pause_modal.end_access_to_factorial_tooltip'
            )}
            icon="info-circle-line"
          />
        </Box>
        <DayPicker
          value={value}
          onChange={onChange}
          pin
          mandatory
          minDate={minDate}
          maxDate={maxDate}
          readonly={readonly}
        />
      </Box>
    </FormRow>
  )
}

export default EmployeeTerminationDatePicker
